import React, { useState } from 'react';
import { Modal } from '@/components/custom/modal/modal';
import { HomeReelsVideo } from './home-reels-video';

// Modal de boas-vindas que abre sozinha ao montar e mostra o vídeo da semana
// (reels vertical). O aluno fecha no X nativo do Modal. Só abre se houver vídeo.
export function HomeWelcomeVideoModal({ videoId }) {
  // Desabilitado por ora: inicia fechado para não abrir sozinho ao montar.
  // Para reativar a abertura automática, troque de volta para useState(true).
  const [show, setShow] = useState(false);

  if (!videoId) return null;

  return (
    <Modal
      show={show}
      onClose={() => setShow(false)}
      contentClassName="modal__content--sm"
    >
      <div className="mx-auto w-full max-w-[360px]">
        <HomeReelsVideo videoId={videoId} />
      </div>
    </Modal>
  );
}
